import { BiHeading, BiTimeFive } from 'react-icons/bi';
import {
    FaUserCircle,
    FaCalendarAlt,
    FaParagraph,
    FaFile,
    FaImage,
    FaPlayCircle,
    FaRegFileAudio,
} from 'react-icons/fa';
import { RiInputMethodFill } from 'react-icons/ri';
import { VscFilePdf } from 'react-icons/vsc';
import {
    MdEmail,
    MdRadioButtonChecked,
    MdCheckBox,
    MdArrowDropDownCircle,
    MdPhotoFilter,
    MdOutlinePictureAsPdf,
    MdOutlineToday,
    MdInsertPageBreak,
} from 'react-icons/md';

export function defaultFormItems() {
    return [
        {
            key: 'Header',
            type: 'textbox',
            name: 'Header Text',
            label: 'Header Text',
            icon: <BiHeading />,
            instruction: 'Header Text',
            group: 'Basic.Elements',
        },
        {
            key: 'FullName',
            name: 'Full Name',
            label: 'Full Name',
            type: 'textbox',
            icon: <FaUserCircle />,
            data: [
                { key: 'firstName', name: 'First Name', type: 'text' },
                { key: 'lastName', name: 'Last Name', type: 'text' },
            ],
            group: 'Basic.Elements',
        },
        {
            key: 'Email',
            name: 'Email',
            label: 'Email',
            type: 'textbox',
            icon: <MdEmail />,
            group: 'Basic.Elements',
        },
        {
            key: 'InputField',
            name: 'InputField',
            label: 'Enter your Question',
            type: 'textbox',
            icon: <RiInputMethodFill />,
            group: 'Basic.Elements',
        },
        {
            key: 'Paragraph',
            name: 'Paragraph',
            label: 'Paragraph',
            icon: <FaParagraph />,
            type: 'textbox',
            instruction:
                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem perferendis rerum facilis molestias nesciunt labore quas quos aspernatur totam sint laudantium sunt a magnam, iure saepe, minima eos eaque qui.',
            group: 'Basic.Elements',
        },
        {
            key: 'Select',
            name: 'Select',
            label: 'Choose a option!',
            icon: <MdArrowDropDownCircle />,
            type: 'select',
            options: [],
            group: 'Choice.Elements',
        },
        {
            key: 'Checkbox',
            name: 'Checkbox',
            label: 'Multiple select option!',
            type: 'checkbox',
            icon: <MdCheckBox />,
            options: [],
            group: 'Choice.Elements',
        },
        {
            key: 'Radio',
            name: 'Radio',
            type: 'radio',
            label: 'Single select option!',
            icon: <MdRadioButtonChecked />,
            options: [],
            group: 'Choice.Elements',
        },
        {
            key: 'Signature',
            name: 'Signature',
            label: 'Signature',
            icon: <FaFile />,
            type: 'signature',
            group: 'Basic.Elements',
        },
        {
            key: 'DatePicker',
            name: 'Date',
            label: 'Date',
            type: 'date',
            icon: <FaCalendarAlt />,
            group: 'Date.and.Time',
        },
        {
            key: 'TimePicker',
            name: 'Time',
            label: 'Time',
            type: 'time',
            icon: <BiTimeFive />,
            group: 'Date.and.Time',
        },
        {
            key: 'DateTimePicker',
            name: 'DateTime',
            label: 'DateTime',
            type: 'datetime',
            icon: <FaCalendarAlt />,
            group: 'Date.and.Time',
        },
        {
            key: 'Image',
            name: 'Image Input',
            label: 'Image',
            type: 'file',
            icon: <FaImage />,
            group: 'File.Upload',
        },
        {
            key: 'File',
            name: 'File',
            label: 'File',
            type: 'file',
            icon: <VscFilePdf />,
            group: 'File.Upload',
        },
        {
            key: 'AudioFile',
            name: 'AudioFile',
            label: 'AudioFile',
            type: 'audio',
            icon: <FaRegFileAudio />,
            group: 'File.Upload',
        },
        {
            key: 'Link',
            name: 'Link',
            label: 'Link:',
            type: 'link',
            icon: <FaPlayCircle />,
            instruction: 'Enter video link source in the Url Field by clicking edit icon',
            group: 'Media.Elements',
        },
        {
            key: 'Photo',
            name: 'Preview Photo',
            label: 'Photo',
            type: 'photo',
            icon: <MdPhotoFilter />,
            instruction: 'Upload image in edit section, click edit icon',
            group: 'Media.Elements',
        },
        {
            key: 'PdfPreviewer',
            name: 'PdfPreviewer',
            label: 'Pdf Previewer',
            type: 'pdf',
            icon: <MdOutlinePictureAsPdf />,
            instruction: 'Upload pdf in edit section, click edit icon',
            group: 'Media.Elements',
        },
        {
            key: 'DateTimeRangePicker',
            name: 'DateTimeRangePicker',
            label: 'DateTime Range Picker',
            type: 'datetime',
            icon: <MdOutlineToday />,
            instruction: 'Choose start and end datetime, per day',
            group: 'Misc.Elements',
        },
        {
            key: 'PageBreak',
            name: 'Page Break',
            label: 'Page',
            type: 'pageelement',
            icon: <MdInsertPageBreak />,
            // instruction:'Break form into switchable pages'
            group: 'Page.Elements',
        },
        // {
        //     key: 'Divider',
        //     type: 'divider',
        //     name: 'Divider',
        //     label: 'Divider',
        //     icon: <FaGripLines />,
        // },
    ];
}
